import Color from '@/Enums/Color.enum';
import { Chip } from '@mui/material';

const ArchivedChip = () => (
  <Chip
    sx={{
      height: '25px',
      borderRadius: '32px',
      background: Color.Grey,
      color: '#fff',
      padding: '0 2px',
      fontSize: 12,
      fontWeight: 500,
    }}
    label='Archived'
  />
);

export default ArchivedChip;
